// extracted by mini-css-extract-plugin
export default {"skillsSection":"Skills_skillsSection__mbSY2","skillsContainer":"Skills_skillsContainer__8zMo2","skillTag":"Skills_skillTag__-udHB"};